import { ADD_SERIES, DELETE_SERIES, GET_SERIES, UPDATE_SERIES } from "../types";

const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_SERIES:
            return {...state, list: payload};

        case UPDATE_SERIES:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_SERIES:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_SERIES:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
